import type { TrialConfig } from '@zafroi/ui-kit';

/**
 * MAVK beta-trial configuration — single source of truth across
 * ERP, Engage, and the warehouse PWA. Encoded UTC moment is
 * 9 June 2026 00:00 IST (= 8 June 2026 18:30 UTC).
 *
 * If you change any of these labels, change them in
 * zafroi-erp-app-prod/src/config/trial.ts as well — until a tenant-
 * config endpoint replaces hand-rolled constants on both sides.
 */
export const MAVK_TRIAL: TrialConfig = {
  tenantName: 'MAVK',
  endDateIso: '2026-06-08T18:30:00.000Z',
  endDateLabel: '8 June 2026',
  renewalDateLabel: '9 June 2026',
};
